import React, { useState } from 'react';
import { TextField } from '@scale/scaleui';
import BuilderHint from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderHint';
import { isNil as _isNil, isEmpty as _isEmpty } from 'lodash';

const StringArrayInput: React.FC<{
  value: string[] | undefined;
  setValue: (value: string[] | undefined) => void;
  hint?: string;
}> = ({ value, setValue, hint }) => {
  const [displayValue, setDisplayValue] = useState<string>(_isNil(value) ? '' : String(value));
  const handleChange = (value: string) => {
    if (_isEmpty(value)) {
      setValue(undefined);
      return;
    }
    let newValue;
    if (value.includes(',')) {
      newValue = value.split(',').map(v => v.trim());
    } else {
      newValue = [value.trim()];
    }
    setValue(newValue);
    setDisplayValue(String(newValue));
  };
  return (
    <div className="flex">
      <TextField
        value={displayValue}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDisplayValue(e.target.value)}
        onBlur={() => handleChange(displayValue)}
      />
      {hint && <BuilderHint name="StringArrayInput" hint={hint} />}
    </div>
  );
};

export default StringArrayInput;
